"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_White(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 284 284",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      background: "#333333"
    }
  }, props), /*#__PURE__*/React.createElement("title", null, "Logos / Vodafone-Logo / White"), /*#__PURE__*/React.createElement("g", {
    id: "Logos-/-Vodafone-Logo-/-White",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.001,142 C284.001,220.425 220.425,284 142.001,284 C63.576,284 0,220.425 0,142 C0,63.575 63.576,0 142.001,0 C220.425,0 284.001,63.575 284.001,142",
    id: "Oval",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.126,221.181975 C104.11,221.3109 63.5199,188.012 63.3419537,134.543 C63.2243,99.183 82.3013,65.147 106.686,44.954 C130.471,25.259 163.056,12.62 192.608,12.5216173 C196.412,12.509 200.39,12.826 202.826,13.65 C176.987,19.009 156.422,43.056 156.512,70.338 C156.515,71.24 156.597,72.203 156.686,72.652 C199.924,83.183 219.552,109.272 219.673371,145.372 C219.792,181.47 191.293,221.0213 143.126,221.181975",
    id: "Speechmark",
    fill: "#E60000"
  })));
}

var _default = ic_White;
exports.default = _default;